import * as store from "./store";
import * as backend from "./backend";

export * from "./types";

export const domain = {
  store,
  backend
};
